import React from "react";
import { Box } from "@mui/material";
import dayjs from "dayjs";

import { isNullOrUndefined } from "utils";
import { EMPTY_CELL_VALUE } from "consts";

import { ApprovalsActions } from "./components/approvals-actions";

export const APPROVALS_COLUMNS = [
  {
    header: "Action",
    Header: <Box sx={{ paddingLeft: "3px" }}>Action</Box>,
    accessorKey: "action",
    Cell: ({ cell, row }: any) => {
      const value = cell.getValue()
      const id = row.original?.id
      return (
        <Box id={row.original?.id} sx={{ textAlign: "right", cursor: "pointer", padding: "8px" }}>
          <ApprovalsActions value={value} id={id} />
        </Box>
      );
    },
    enableSorting: true,
    size: 80,
  },
  {
    header: "Name",
    Header: <Box sx={{ paddingLeft: "3px" }}>Name</Box>,
    accessorKey: "user",
    Cell: ({ cell }: any) => {
      const value = cell.getValue()

      return (
        <>{value}</>
      );
    },
    enableSorting: true,
    size: 80,
  },
  {
    header: "Signature",
    Header: <Box sx={{ paddingLeft: "3px" }}>Signature</Box>,
    accessorKey: "userSign",
    Cell: ({ cell }: any) => {
      const value = cell.getValue()

      return (
        <>{value}</>
      );
    },
    enableSorting: true,
    size: 80,
  },
  {
    header: "Time Stamp",
    Header: <Box sx={{ paddingLeft: "3px" }}>Time Stamp</Box>,
    accessorKey: "createDate",
    Cell: ({ cell }: any) => {
      const value = cell.getValue()

      return (
        <>{dayjs(value).format('MM/DD/YYYY HH:mm:ss')}</>
      );
    },
    enableSorting: true,
    size: 125,
  },
  {
    header: "Site Name",
    Header: <Box sx={{ paddingLeft: "3px" }}>Site Name</Box>,
    accessorKey: "siteName",
    Cell: ({ cell }: any) => cell.getValue(),
    enableSorting: true,
    size: 140,
  },
  {
    header: "Month/Year",
    Header: <Box sx={{ paddingLeft: "3px" }}>Month/Year</Box>,
    accessorKey: "monthYear",
    Cell: ({ cell }: any) => cell.getValue(),
    enableSorting: true,
    size: 80,
  },
];

export const DETAIL_MODAL_COLUMNS = [
  {
    header: "Site",
    Header: <Box sx={{ paddingLeft: "3px" }}>Site</Box>,
    accessorKey: "siteName",
    enableSorting: true,
    size: 200,
  },
  {
    header: "Applicable S1/S2 Usage",
    Header: <Box sx={{ paddingLeft: "3px" }}>Applicable S1/S2 Usage</Box>,
    accessorKey: "applicableScopesUsage",
    Cell: ({ row }: any) => {
      const {
        applicableScope1Usage,
        applicableScope1UsageUnit,
        applicableScope2Usage,
        applicableScope2UsageUnit,
      } = row.original;

      if (isNullOrUndefined(applicableScope1Usage) && isNullOrUndefined(applicableScope2Usage)) {
        return EMPTY_CELL_VALUE;
      }
      return (
        <>{`${applicableScope1Usage || 0} ${applicableScope1UsageUnit} / ${applicableScope2Usage || 0} ${applicableScope2UsageUnit}`}</>
      );
    },
    enableSorting: true,
    size: 250,
  },
  {
    header: "Applicable S1/S2 Emissions",
    Header: <Box sx={{ paddingLeft: "3px" }}>Applicable S1/S2 Emissions</Box>,
    accessorKey: "applicableScopesEmissions",
    Cell: ({ row }: any) => {
      const {
        applicableScope1Emissions,
        applicableScope1EmissionsUnit,
        applicableScope2Emissions,
        applicableScope2EmissionsUnit,
      } = row.original;

      if (isNullOrUndefined(applicableScope1Emissions) && isNullOrUndefined(applicableScope2Emissions)) {
        return EMPTY_CELL_VALUE;
      }
      return (
        <>{`${applicableScope1Emissions || 0} ${applicableScope1EmissionsUnit} / ${applicableScope2Emissions || 0} ${applicableScope2EmissionsUnit}`}</>
      );
    },
    enableSorting: true,
    size: 250,
  },
];

export const ADD_MODAL_COLUMNS = [
  {
    header: "Select All",
    Header: <Box sx={{ paddingLeft: "3px" }}>Select All</Box>,
    accessorKey: "label",
    Cell: ({ cell }: any) => cell.getValue(),
    enableSorting: true,
    size: 600,
    minSize: 600,
    maxSize: 600,
  },
];
